import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import MultimediaForm from '../form/MultimediaForm';
import { MultimediaValues } from '../model/multimediaModel';
import { ROUTES } from '../../../core/router/routes';
import SnackbarSettings from '../../../components/Snackbar/SnackbarSettings/SnackbarSettings';
import * as Selectors from '../redux/multimediaSelectors';
import * as Actions from '../redux/multimediaActions';
import useMainProgressContext from '../../../components/progress/MainProgress/context/MainProgressContext';

const initialValues: MultimediaValues = {
  file: '',
  name: '',
};

const breadcrumbs = [
  {
    label: 'multimedia.add',
    to: null,
  },
];

interface MultimediaAddProps {
  doNotRedirect?: boolean;
}

const MultimediaAdd: FC<MultimediaAddProps> = ({ doNotRedirect }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const apiRequestState = useSelector(Selectors.apiMultimediaRequestState);
  const apiRequestError = useSelector(Selectors.apiMultimediaRequestError);
  const { show, hide } = useMainProgressContext();

  useEffect(() => {
    hide();
  }, []);

  return (
    <>
      <SnackbarSettings
        successMessage="multimedia.snackbar.add_success"
        apiRequestState={apiRequestState}
        apiRequestError={apiRequestError}
        setApiRequestState={Actions.setApiMultimediaRequestState}
        onSuccess={() => {
          doNotRedirect ? dispatch(Actions.getAllMultimedia({})) : history.push(ROUTES.MULTIMEDIA.LIST);
        }}
      />
      <MultimediaForm
        breadcrumbs={breadcrumbs}
        title="multimedia.add"
        initialValues={initialValues}
        onSubmit={(values: MultimediaValues) => {
          show();
          dispatch(Actions.addMultimedia(values));
        }}
      />
    </>
  );
};

export default MultimediaAdd;
